/* Bezorgvoorkeur thuisbatterij: slaat de keuzes direct op als winkelwagen-attributen. */
(function () {
  if (window.__bezorgvoorkeurInit) return;
  window.__bezorgvoorkeurInit = true;

  var timer = null;

  function collect(box) {
    var days = Array.prototype.slice
      .call(box.querySelectorAll('input[data-bzv-dag]:checked'))
      .map(function (c) { return c.value; });
    var hidden = box.querySelector('input[data-bzv-dagen]');
    if (hidden) hidden.value = days.join(', ');

    var attrs = {};
    box.querySelectorAll('[data-bzv-attr]').forEach(function (el) {
      attrs[el.getAttribute('data-bzv-attr')] = el.value || '';
    });
    return attrs;
  }

  function save(box, delay) {
    var attrs = collect(box);
    var status = box.querySelector('[data-bzv-status]');
    clearTimeout(timer);
    timer = setTimeout(function () {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      })
        .then(function (r) {
          if (status) status.textContent = r.ok ? 'Voorkeur opgeslagen ✓' : '';
        })
        .catch(function () {});
    }, delay);
  }

  function boxFor(target) {
    return target && target.closest ? target.closest('[data-bezorgvoorkeur]') : null;
  }

  document.addEventListener('change', function (e) {
    var box = boxFor(e.target);
    if (box) save(box, 100);
  });

  document.addEventListener('input', function (e) {
    var box = boxFor(e.target);
    if (box && e.target.tagName === 'TEXTAREA') save(box, 600);
  });
})();